module.exports = __webpack_public_path__ + "static/media/viren_patil.5397e226.jpg";